import {get, post} from '../index'
export default {
  // 海报分类列表
  getPosterClassifyList (querys) {
    return get('/marketing/admin/posterTypeAdmin/listPosterType', querys)
  },
  // 海报分类详情
  getPosterClassifyInfo (querys) {
    return get('/marketing/admin/posterTypeAdmin/getPosterType', querys)
  },
  // 增加海报分类
  addPosterClassifyInfo (querys) {
    return post('/marketing/admin/posterTypeAdmin/createPosterType', querys)
  },
  // 编辑海报分类
  editPosterClassifyInfo (querys) {
    return post('/marketing/admin/posterTypeAdmin/updatePosterType', querys)
  },
  // 上下架、删除海报分类
  updatePosterClassifyInfo (querys) {
    return post('/marketing/admin/posterTypeAdmin/changeStatus', querys)
  },
  // 获取海报列表
  getPosterList (querys) {
    return get('/marketing/admin/posterAdmin/listPoster', querys)
  },
  // 海报列表下拉菜单
  getPosterSelectedOptions () {
    return get('/marketing/admin/posterTypeAdmin/listAllPosterType')
  },
  // 获取海报详情
  getPosterInfo (querys) {
    return get('/marketing/admin/posterAdmin/getPoster', querys)
  },
  // 新增海报
  addPosterInfo (querys) {
    return post('/marketing/admin/posterAdmin/createPoster', querys)
  },
  // 上下架、删除海报
  updatePoster (querys) {
    return post('/marketing/admin/posterAdmin/changeStatus', querys)
  },
  // 编辑海报
  editPosterInfo (querys) {
    return post('/marketing/admin/posterAdmin/updatePoster', querys)
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/poster.js